// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T17:19:54.870Z
// Property: The Enclave at Brookside (ID: 5733056069500928)
// Collections: 36 amenities, 11 floorplans (live), 22 photos, 41 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5733056069500928",
  "property_external_id": "924388",
  "property_zillow_url": "https://www.zillow.com/apartments/tulsa-ok/the-enclave-at-brookside/Cgr2Qn/",
  "property_apartments_url": "https://www.apartments.com/the-enclave-at-brookside-tulsa-ok/p5bhsst/",
  "property_google_business_url": "https://www.google.com/maps/place/Enclave+at+Brookside/data=!4m2!3m1!1s0x0:0x487db4d3eef1489?sa=X&ved=2ahUKEwjQ48zuirmSAxXT6skDHQ2TFUQQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47726251875",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-enclave-at-brookside",
  "property_name": "The Enclave at Brookside",
  "property_website_url": "https://www.enclavebrooksideapts.com/",
  "property_domain": "https://www.enclavebrooksideapts.com/",
  "property_address": "1414 East 39th St.",
  "property_full_address": "1414 E 39th St, Tulsa, OK 74105",
  "property_address_1": "1414 E 39th St",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74105",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "Brookside",
  "property_address_latitude": "36.10568540000001",
  "property_address_longitude": "-95.9723539",
  "property_email": "enclaveatbrookside@weidner.com",
  "property_phone": "5392860925",
  "property_call_tracking_phone": "918-289-2167",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Refined Brookside living starts here.</strong> Explore open one- and two-bedroom apartments with high ceilings, oversized windows, granite-finished kitchens, and polished community spaces—then schedule your tour at The Enclave at Brookside.</p>",
  "property_long_description": "<p><strong>Refined Brookside living starts here.</strong> At The Enclave at Brookside, you’re close to the Peoria Avenue dining and shopping corridor, Whole Foods Market, Reasor’s, Heller Park, River Parks, and Tulsa’s celebrated Gathering Place—giving you an easy connection to Midtown convenience, outdoor recreation, and neighborhood energy.</p><p>Choose from thoughtfully designed <a href=\"/floor-plans\">one- and two-bedroom floor plans</a> with open layouts, high ceilings, oversized windows, in-home washer and dryer, walk-in closets, and modern kitchens with granite finishes and full appliance packages. Beyond your front door, <a href=\"/amenities\">community amenities</a> extend your space with a resort-style pool, cabana and grill area, fire-pit seating, courtyards, fitness center, yoga studio, resident lounge, conference room, game room, covered parking, controlled access, and a pet play area. From relaxed evenings at home to weekends exploring Brookside, Philbrook Museum of Art, and the Arkansas River, this is Tulsa apartment living with a polished Midtown rhythm.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-64ca-7020-84ad-45a7a640f164.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and an island.",
    "public_id": "019d01a1-64ca-7020-84ad-45a7a640f164",
    "storage_key": "property/5733056069500928/019d01a1-64ca-7020-84ad-45a7a640f164.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "240",
  "property_year_built": "2014",
  "property_year_renovated": null,
  "property_walk_score": "83",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.75",
  "property_admin_fee": "150",
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": "250",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://enclavebrooksideapts.securecafe.com/onlineleasing/the-enclave-at-brookside/floorplans.aspx",
  "property_resident_portal_url": "https://enclavebrooksideapts.securecafenet.com/residentservices/the-enclave-at-brookside/userlogin",
  "property_apply_now_url": "https://enclavebrooksideapts.securecafe.com/onlineleasing/the-enclave-at-brookside/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-0748-719e-bda1-3fd14405f3fd.webp",
  "property_primary_logo_media": {
    "alt_text": "The Enclave at Brookside",
    "public_id": "019d01a2-0748-719e-bda1-3fd14405f3fd",
    "storage_key": "property/5733056069500928/019d01a2-0748-719e-bda1-3fd14405f3fd.webp",
    "width": 138,
    "height": 75
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a3-4cc1-7258-89e8-5d24ee68841f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo.",
    "public_id": "019d01a3-4cc1-7258-89e8-5d24ee68841f",
    "storage_key": "property/5733056069500928/019d01a3-4cc1-7258-89e8-5d24ee68841f.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a3-5bdb-72df-808d-0c5b7116175f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Enclave at Brookside Apartment Homes logo.",
    "public_id": "019d01a3-5bdb-72df-808d-0c5b7116175f",
    "storage_key": "property/5733056069500928/019d01a3-5bdb-72df-808d-0c5b7116175f.webp",
    "width": 138,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a3-63f9-72fd-be45-e09f4fefe246.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Enclave at Brookside Apartment Homes logo",
    "public_id": "019d01a3-63f9-72fd-be45-e09f4fefe246",
    "storage_key": "property/5733056069500928/019d01a3-63f9-72fd-be45-e09f4fefe246.webp",
    "width": 138,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#792A7F",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1510",
  "property_sqft_min": "724",
  "property_sqft_max": "1510",
  "property_price_range": "1371 - 3290",
  "property_price_min": "1371",
  "property_price_max": "3290",
  "property_available_units": 30,
  "property_facebook_url": "https://www.facebook.com/TheEnclaveAtBrooksideApartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJEbCM2E-TtocRiRTvPk3bhwQ",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Enclave at Brookside",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your Home",
  "property_home_amenities_blurb": "<p><strong>More room for the day to unfold.</strong> Start in the fitness center or yoga room, settle in by the pool and cabana, then wind down at the grills or outdoor fire pits. Gated access, elevators, online services, night patrol, and door-to-door trash pickup add everyday ease, while granite countertops, sleek cabinetry, oversized windows, walk-in closets, and in-home washers and dryers bring polished comfort inside.</p>",
  "property_home_floorplans_blurb": "<p><strong>One- and two-bedroom layouts with room to live well.</strong> At The Enclave at Brookside, open living areas, lofty ceilings, oversized windows, walk-in closets, and included washers and dryers bring everyday ease to every floor plan. Select homes add granite island kitchens, under-cabinet lighting, patios or balconies, courtyard or pool views, and garden tubs or walk-in showers.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at The Enclave at Brookside.</strong> Browse bright interiors with oversized windows, granite kitchens, sleek cabinetry, walk-in closets, and in-home laundry, then picture the spaces beyond your front door—from the pool and cabana to the grill area, courtyard seating, fitness spaces, and resident lounge. Every photo brings the textures, light, and flow of this Brookside Tulsa community into sharper focus.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Brookside, right outside your door.</strong> From The Enclave at Brookside, Peoria Avenue’s village stretch puts coffee at Shades of Brown, local shops, and favorites like R Bar &amp; Grill and Café Olé within easy reach. River Parks trails, Gathering Place, and the 700 Peoria AERO route add open-air escapes and simple Tulsa connections. Explore the neighborhood map to see what surrounds home.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about The Enclave at Brookside.</strong> Reviews point to attentive service, clean community spaces, and a Brookside location close to everyday dining and grocery stops. The leasing and maintenance teams earn frequent shoutouts for friendly, prompt support, while reviewers call the setting an “Amazing location” with an “unbeatable” ambiance. Read more to see what stands out.</p>",
  "property_neighborhood_blurb": "<p><strong>Brookside starts at street level.</strong> From The Enclave at Brookside, you’re positioned near Peoria Avenue’s village stretch, where a morning at Brookside By Day can turn into coffee at Shades of Brown, browsing local shops, or dinner and drinks at R Bar &amp; Grill and Café Olé without leaving Midtown. The neighborhood mixes patio energy, everyday errands, and easy connections in a compact setting, with the 700 Peoria AERO route nearby for trips toward Downtown Tulsa and beyond. When the day calls for open air, head west to the River Parks trails or spend an afternoon at Gathering Place along the Arkansas River. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Brookside fits around home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that stretch your day beyond the apartment.</strong> At The Enclave at Brookside, you can move from an energizing workout in the fitness center or yoga room to a poolside afternoon under the cabana, then unwind near the grill or outdoor fire pits as the evening settles in. The gated community setting, elevator access, online services, night patrol, and door-to-door trash pickup help keep daily routines simple.</p><p>Inside, modern finishes add polish where you use them most: granite countertops, sleek cabinetry, under-cabinet lighting, washers and dryers, walk-in closets, and sunny oversized windows. Select homes add island kitchens, patios or balconies, pool or courtyard views, garden tubs, walk-in showers, and individual security systems. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Refined Brookside living is ready when you are.</strong> Start your application online for a one- or two-bedroom home with open layouts, high ceilings, oversized windows, in-home laundry, walk-in closets, and granite-finished kitchens—plus polished community spaces that make everyday Tulsa living feel effortless.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> Contact The Enclave at Brookside leasing team for help exploring refined Tulsa apartment living, from one- and two-bedroom floor plans to modern finishes and convenient Midtown access. We’re here to make your next step simple.</p>",
  "property_faqs_blurb": "<p><strong>Questions about The Enclave at Brookside?</strong> Find helpful answers about floor plans, amenities, leasing, and everyday living in this refined Midtown Tulsa community. If you need more details or a next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that matches your rhythm.</strong> The Enclave at Brookside offers one- and two-bedroom apartment homes in Brookside, ranging from smart, easy-to-furnish one-bedroom designs to more expansive two-bedroom, two-bath layouts with room to spread out. Inside, open living areas, lofty ceilings, sunny oversized windows, walk-in closets, and included washers and dryers help each floor plan feel polished and practical.</p><p>As you compare available homes, look for details that fit the way you like to live—granite island kitchens, integrated under-cabinet lighting, dining areas, patios or balconies, courtyard or pool views, and garden tubs or walk-in showers in select residences. Browse current availability, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See the details before you step inside.</strong> The photo gallery at The Enclave at Brookside brings the property into focus—from bright apartment interiors with oversized windows and polished granite kitchens to calm corners made for everyday routines.</p><p>Swipe through open living spaces, sleek cabinetry, walk-in closets, and in-home laundry, then let the view move outdoors to the pool, cabana, grill area, courtyard seating, fitness spaces, and resident lounge. Each image gives you a clearer sense of texture, light, and flow across this Brookside apartment community in Tulsa. When a space catches your eye, compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see it in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore refined Brookside living.</strong> Use the interactive map to browse available <a href=\"/floor-plans\">one- and two-bedroom apartments</a>, see how The Enclave connects to Peoria Avenue convenience, Midtown recreation, and nearby neighborhood highlights, then plan your next step from map view to tour.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, zoomies, and quiet naps.</strong> At The Enclave at Brookside, your cat or dog can feel at home with pet-friendly apartment living in Brookside and an on-site <a href=\"/amenities\">Pet Play Area/Dog Park</a> made for quick outdoor breaks between errands and downtime.</p><p>Inside, open layouts, sunny oversized windows, in-home washers and dryers, and select patios or balconies help daily pet routines feel easier—from fresh-air mornings to cozy evenings in. When you want a longer outing, nearby leashed trails add a simple way to stretch the day beyond the community. Review the pet guidelines on this page, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly living fits at The Enclave.</p>",
  "property_referafriend_blurb": "<p><strong>Share refined Brookside living.</strong> Love the open layouts, granite-finished kitchens, resort-style spaces, and polished Midtown rhythm at The Enclave at Brookside? Invite a friend to discover the community you call home—send a referral and help them find their next Tulsa apartment here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Enclave at Brookside.</strong><br>Keep your polished Midtown rhythm moving—log in to pay rent, submit maintenance requests, and manage your account with ease, all from the comfort of your Brookside apartment home.</p>",
  "property_reviews_blurb": "<p><strong>See why residents keep choosing The Enclave at Brookside.</strong> Reviews consistently highlight a helpful, attentive team, clean community spaces, and a Brookside setting that puts everyday dining and grocery stops close by.</p><p>Residents praise the leasing and maintenance teams by name, from Cassidy and Brenda in the office to Joel, Ramon, and Charles for friendly service and quick support. One reviewer calls it an “Amazing location. Great area,” while another says the “ambiance is unbeatable.” Read the reviews below to get a firsthand feel for life at The Enclave at Brookside.</p>",
  "property_created_at": "1752256647616",
  "property_scheduletour_blurb": "<p><strong>See refined Brookside living up close.</strong> Tour open one- and two-bedroom layouts with high ceilings, oversized windows, granite-finished kitchens, and in-home laundry—then explore the polished community spaces that extend life beyond your front door. Schedule your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong> The leasing team will be in touch soon to help with your next steps. In the meantime, picture refined Brookside living with open one- and two-bedroom layouts, modern granite-finished kitchens, inviting resident spaces, and easy access to Midtown convenience and outdoor recreation.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through The Enclave at Brookside from wherever you are.</strong> Start with immersive virtual tours of the Fitness Center and community Play Room, then step inside select apartment layouts to compare the flow of the Alta and Vogue one-bedroom homes with the roomier Nuvo and Panorama two-bedroom designs. As you move through each tour, look for the details that matter in real life: open sightlines, bright windows, modern kitchens, in-home laundry, and spaces that feel easy to picture with your own furniture.</p><p>Use these tours to narrow your favorites before browsing current <a href=\"/floor-plans\">floor plans</a>, exploring more <a href=\"/gallery\">photos</a>, or setting up an in-person visit. When you’re ready for a closer look in Brookside, <a href=\"/schedule-a-tour\">schedule a tour</a> with the leasing team.</p>",
  "property_copyright": "2026 All Rights Reserved. The Enclave at Brookside",
  "property_seo_title_home": "The Enclave at Brookside |  Apartments in Tulsa, OK",
  "property_seo_description_home": "Experience luxury living at The Enclave at Brookside in Tulsa, OK. Choose from spacious floor plans and enjoy top-tier amenities designed for your lifestyle!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal sanctuary at The Enclave at Brookside in Tulsa, OK. Browse our one and two-bedroom floor plans and embrace a life of comfort and style!",
  "property_seo_title_amenities": "Amenities | Tulsa, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience vibrant living at The Enclave at Brookside! Unwind with upscale amenities, from a relaxing pool to a pet-friendly space. Your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, OK",
  "property_seo_description_gallery": "Picture life at The Enclave at Brookside in Tulsa, OK! Luxurious amenities, stunning views, and vibrant living await. Your dream home starts here!",
  "property_seo_title_virtualtours": "Virtual Tours | The Enclave at Brookside Apartments",
  "property_seo_description_virtualtours": "Experience The Enclave at Brookside in Tulsa, OK! Take a virtual tour of our charming one and two-bedroom apartments—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Enclave at Brookside Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at The Enclave at Brookside! Use our interactive map to browse spacious apartments with luxurious amenities in Tulsa, OK.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, OK",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding The Enclave at Brookside in Tulsa, OK. From local hotspots to serene parks, adventure is just outside your door!",
  "property_seo_title_contact": "Contact Us | The Enclave at Brookside",
  "property_seo_description_contact": "Contact The Enclave at Brookside in Tulsa, OK! Our leasing team is here to answer your questions about our one and two-bedroom floor plans!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, OK",
  "property_seo_description_faqs": "Find answers to your questions about The Enclave at Brookside in Tulsa, OK. Learn more about amenities, floor plans, and pet-friendly living today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, OK",
  "property_seo_description_reviews": "Experience life at The Enclave at Brookside in Tulsa, OK. Read our resident reviews and see why our vibrant community with stunning amenities feels like home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, OK",
  "property_seo_description_applynow": "Find comfort at The Enclave at Brookside in Tulsa, OK. Enjoy spacious floor plans, fabulous amenities, and a vibrant community. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Enclave at Brookside",
  "property_seo_description_residentaccess": "Log in to The Enclave at Brookside portal for easy rent payments, maintenance requests, and community updates in Tulsa, OK. Access now!",
  "property_seo_title_referafriend": "Refer A Friend | The Enclave at Brookside",
  "property_seo_description_referafriend": "Refer a friend to The Enclave at Brookside in Tulsa, OK! Great friends make great neighbors—share the joy of living in our vibrant apartment community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Enclave at Brookside",
  "property_seo_description_scheduletour": "Experience vibrant living at The Enclave at Brookside in Tulsa, OK. Schedule your tour today and find your ideal home in our welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | The Enclave at Brookside",
  "property_seo_description_privacy": "Your privacy matters at The Enclave at Brookside. Learn how we protect your information and ensure peace of mind in your Tulsa home. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Enclave at Brookside",
  "property_seo_description_accessibility": "At The Enclave at Brookside in Tulsa, we prioritize digital inclusivity. Find out how we're committed to accessibility for all residents. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Enclave at Brookside",
  "property_seo_description_sitemap": "Uncover your perfect living space at The Enclave at Brookside in Tulsa, OK. Navigate our sitemap for a seamless journey to your new home!",
  "property_seo_title_thankyou": "Thank You | The Enclave at Brookside",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to luxurious living at The Enclave at Brookside in Tulsa has begun. Our team will be in touch soon!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791389311212",
  "amenities": [
    {
      "id": "ec_aa63d92fb815413f336d2c45",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382908",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff473300f18ac3b2d055290c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382906",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d99d7-c616-71d8-8119-359dddf94e2e.webp",
      "amenity_image_media": {
        "alt_text": "Modern fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019d99d7-c616-71d8-8119-359dddf94e2e",
        "storage_key": "property/5733056069500928/019d99d7-c616-71d8-8119-359dddf94e2e.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "a gym with treadmills and weights in the lobby of a building",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_caf4658c7ae3faafebb1426f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382890",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d0c0af38381454f932df746b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382892",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e3b6f7dcfced5475f623764",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382895",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bd250f7ad5ad5381870c287c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382902",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67384fe8d4be80186c05614f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382903",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fdd52bc5b92b61e55c3a0f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382907",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d053257a9abd755d4936cdf5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382905",
      "title": "Pet Play Area/ Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da1a9377537a3057d84089af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382899",
      "title": "Game room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a27fe04c490172f48706017",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382911",
      "title": "Yoga Studio/Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a83fde6c2ba6b5226c7e6916",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382893",
      "title": "Trash Pickup - Door to Door",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d64e8614fceaaeff49f471f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382897",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-a11d-704e-95ce-c0b62ccb325f.webp",
      "amenity_image_media": {
        "alt_text": "Communal area with a large wooden table, chairs, and a coffee bar.",
        "public_id": "019d01a1-a11d-704e-95ce-c0b62ccb325f",
        "storage_key": "property/5733056069500928/019d01a1-a11d-704e-95ce-c0b62ccb325f.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a painting hangs on the wall in front of a long table with four stools",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd1cab5b7ddda735f7abe501",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382898",
      "title": "Conference Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-f8a8-7748-80f5-b4ce725e9b3d.webp",
      "amenity_image_media": {
        "alt_text": "Community room with a large oval table, chairs, and a TV.",
        "public_id": "019d01a1-f8a8-7748-80f5-b4ce725e9b3d",
        "storage_key": "property/5733056069500928/019d01a1-f8a8-7748-80f5-b4ce725e9b3d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a meeting room with a table and chairs",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5399d76766266eb7d18a02dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382901",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a07e117bdda3eef1cfff527",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382904",
      "title": "Cabana/ Gazebo",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94822d701257bcacf5ff424b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382909",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f5329bed7317cea1d2430cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382910",
      "title": "Weight Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6653c3ba8e1f2107b12ca53e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "124800149",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f7501e864a2da503d2f67e1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382918",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_016be701992735cee59f9e70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382921",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-787e-7010-b0a5-5a226e50697f.webp",
      "amenity_image_media": {
        "alt_text": "In-unit laundry room with stacked washer and dryer, shelf with cleaning supplies, and towels.",
        "public_id": "019d01a1-787e-7010-b0a5-5a226e50697f",
        "storage_key": "property/5733056069500928/019d01a1-787e-7010-b0a5-5a226e50697f.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a small laundry room with a washer and dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_057e9461ea6bf6cc7c25e4e2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382926",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d99d7-c033-71ef-9cf7-0a437519a17d.webp",
      "amenity_image_media": {
        "alt_text": "Master bedroom with a king-size bed, dresser, and an ensuite bathroom.",
        "public_id": "019d99d7-c033-71ef-9cf7-0a437519a17d",
        "storage_key": "property/5733056069500928/019d99d7-c033-71ef-9cf7-0a437519a17d.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a bedroom with a large bed and a ceiling fan",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6961d5b5646864f4a81f7ae6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382920",
      "title": "Patio/Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac47bfbca64eb750770aa81a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382912",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_952c9f9608a1b91ee76a345e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382914",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d99d7-c085-70dc-8cc4-12a264b396c5.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and an island.",
        "public_id": "019d99d7-c085-70dc-8cc4-12a264b396c5",
        "storage_key": "property/5733056069500928/019d99d7-c085-70dc-8cc4-12a264b396c5.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "a kitchen with a sink and a stove",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebc8de2eb1719b07b1da6231",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382919",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-75ed-745b-a4b0-1f69ae16633d.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with a beige sofa, abstract art, and a zebra rug.",
        "public_id": "019d01a1-75ed-745b-a4b0-1f69ae16633d",
        "storage_key": "property/5733056069500928/019d01a1-75ed-745b-a4b0-1f69ae16633d.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a living room with a ceiling fan and a large window",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d3bd2b5c61b77c778bd8aed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "92286964",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_51f436283c35d6e7863f4214",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382916",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_860f8f6ffea9b95251613b67",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "89788664",
      "title": "Pre-Installed Wi-Fi with 1st Month Free from Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58a806d438d37e997d9ca3ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382915",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3963792be9c40d8cfed01569",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382917",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04da846892b1dc8696178371",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382923",
      "title": "Dining Room*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-66f2-723f-88ae-0f96ae6609bd.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, marble countertops, and a breakfast bar with stools.",
        "public_id": "019d01a1-66f2-723f-88ae-0f96ae6609bd",
        "storage_key": "property/5733056069500928/019d01a1-66f2-723f-88ae-0f96ae6609bd.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "a kitchen with a counter top and stools",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ec1b5b438d44a823036603d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "86382925",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d5535b382e7cecd0f0ddf7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "121630085",
      "title": "*Only available in select homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7452dcd3e63946b2833f3e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "126781755",
      "title": "Courtyard View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6f401e72f8d4a6a5108c6e0f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "yardi",
      "external_id": "126781756",
      "title": "Pool View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_c34575ae9d5ab1824f8e23f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-64ca-7020-84ad-45a7a640f164.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "019d01a1-64ca-7020-84ad-45a7a640f164",
        "storage_key": "property/5733056069500928/019d01a1-64ca-7020-84ad-45a7a640f164.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring dark wood cabinetry, sleek granite countertops, a central island, and stainless steel appliances for a modern living experience.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets, granite countertops, stainless steel appliances, and an island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (18).jpg"
    },
    {
      "id": "ec_eb9b5c6ea2d9811755fa3012",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-66f2-723f-88ae-0f96ae6609bd.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, marble countertops, and a breakfast bar with stools.",
        "public_id": "019d01a1-66f2-723f-88ae-0f96ae6609bd",
        "storage_key": "property/5733056069500928/019d01a1-66f2-723f-88ae-0f96ae6609bd.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this fully equipped kitchen featuring sleek dark wood cabinetry, elegant marble countertops, and a convenient breakfast bar for casual dining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, marble countertops, and a breakfast bar with stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (19).jpg"
    },
    {
      "id": "ec_453a436260132e8de53963d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-6523-7139-abd8-03f38c37d4a1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets and granite countertops, open to a living area.",
        "public_id": "019d01a1-6523-7139-abd8-03f38c37d4a1",
        "storage_key": "property/5733056069500928/019d01a1-6523-7139-abd8-03f38c37d4a1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Stylish and functional kitchen featuring dark wood cabinetry, sleek granite countertops, and modern appliances. Opens to a well-appointed living space, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark cabinets and granite countertops, open to a living area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (20).jpg"
    },
    {
      "id": "ec_2ec32fcbd470ff91245ea22b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-6ade-77cc-80c3-0714c6fe3d50.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, marble countertops, and stainless steel appliances.",
        "public_id": "019d01a1-6ade-77cc-80c3-0714c6fe3d50",
        "storage_key": "property/5733056069500928/019d01a1-6ade-77cc-80c3-0714c6fe3d50.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover a chef's dream kitchen with ample counter space and modern appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, marble countertops, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (21).jpg"
    },
    {
      "id": "ec_22eceba1f71a51c1979307c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-7452-7128-b1ba-0c84bd55f5a9.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern furniture and decor.",
        "public_id": "019d01a1-7452-7128-b1ba-0c84bd55f5a9",
        "storage_key": "property/5733056069500928/019d01a1-7452-7128-b1ba-0c84bd55f5a9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room with a comfortable sectional sofa, coffee table, and a modern kitchen with bar seating. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with modern furniture and decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (22).jpg"
    },
    {
      "id": "ec_a7c78da2b1f4ed0cd461e8d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-75ed-745b-a4b0-1f69ae16633d.webp",
      "image_media": {
        "alt_text": "Modern living room with a beige sofa, abstract art, and a zebra rug.",
        "public_id": "019d01a1-75ed-745b-a4b0-1f69ae16633d",
        "storage_key": "property/5733056069500928/019d01a1-75ed-745b-a4b0-1f69ae16633d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this stylish apartment, featuring a spacious living room with elegant furnishings and contemporary decor.",
      "link": "false",
      "alt_text": "Modern living room with a beige sofa, abstract art, and a zebra rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (23).jpg"
    },
    {
      "id": "ec_f2a9637c5834cf1cba9a2812",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-787e-7010-b0a5-5a226e50697f.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with stacked washer and dryer, shelf with cleaning supplies, and towels.",
        "public_id": "019d01a1-787e-7010-b0a5-5a226e50697f",
        "storage_key": "property/5733056069500928/019d01a1-787e-7010-b0a5-5a226e50697f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry room featuring a stacked washer and dryer, shelving with cleaning supplies, and a towel rack.",
      "link": "false",
      "alt_text": "In-unit laundry room with stacked washer and dryer, shelf with cleaning supplies, and towels.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (24).jpg"
    },
    {
      "id": "ec_8d3f008a968ea54a4e214f8e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-7b34-775f-9f85-b7ff0ba5e079.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertops and wood-look tile flooring in bathroom.",
        "public_id": "019d01a1-7b34-775f-9f85-b7ff0ba5e079",
        "storage_key": "property/5733056069500928/019d01a1-7b34-775f-9f85-b7ff0ba5e079.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, modern fixtures, and a walk-in closet. The flooring is a stylish wood-look tile.",
      "link": "false",
      "alt_text": "Double vanity with granite countertops and wood-look tile flooring in bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (25).jpg"
    },
    {
      "id": "ec_ceceaaf91daa650e727a24ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-93ad-757a-b5e2-4dea80ddca07.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge seating and a bar with a TV above a stone fireplace.",
        "public_id": "019d01a1-93ad-757a-b5e2-4dea80ddca07",
        "storage_key": "property/5733056069500928/019d01a1-93ad-757a-b5e2-4dea80ddca07.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, complete with comfortable lounge seating and an outdoor bar area featuring a TV and fireplace.",
      "link": "false",
      "alt_text": "Outdoor pool area with lounge seating and a bar with a TV above a stone fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (26).jpg"
    },
    {
      "id": "ec_2d4602ff1b5d574f2d4d6e83",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-8aba-70c4-9216-52f78d1d4a99.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and mirror.",
        "public_id": "019d01a1-8aba-70c4-9216-52f78d1d4a99",
        "storage_key": "property/5733056069500928/019d01a1-8aba-70c4-9216-52f78d1d4a99.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a plush bed, elegant dresser, and a decorative mirror. The room offers ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom with a large bed, dresser, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (27).jpg"
    },
    {
      "id": "ec_ec8fdc8ddc3528f55322ee5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-8d4f-764e-a973-a081082de9f2.webp",
      "image_media": {
        "alt_text": "Open-plan living area with kitchen island and stools, leading to hallway.",
        "public_id": "019d01a1-8d4f-764e-a973-a081082de9f2",
        "storage_key": "property/5733056069500928/019d01a1-8d4f-764e-a973-a081082de9f2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious open-plan living area featuring a modern kitchen island with bar stools. The apartment boasts hardwood-style flooring and a neutral color palette.",
      "link": "false",
      "alt_text": "Open-plan living area with kitchen island and stools, leading to hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (28).jpg"
    },
    {
      "id": "ec_a6c37d5affe3f2d234da608d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-8769-719e-908b-1adc05852c81.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, blinds on window, and ceiling fan.",
        "public_id": "019d01a1-8769-719e-908b-1adc05852c81",
        "storage_key": "property/5733056069500928/019d01a1-8769-719e-908b-1adc05852c81.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious empty bedroom featuring plush carpeting, a ceiling fan, and natural light filtering through the window blinds.",
      "link": "false",
      "alt_text": "Empty bedroom with beige walls, blinds on window, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (29).jpg"
    },
    {
      "id": "ec_b910c6386fd6a7b970bc0f8d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-9694-74ce-9c24-fc0dc87d2bfb.webp",
      "image_media": {
        "alt_text": "Stylish community lounge with pool table, comfortable seating, and decorative elements.",
        "public_id": "019d01a1-9694-74ce-9c24-fc0dc87d2bfb",
        "storage_key": "property/5733056069500928/019d01a1-9694-74ce-9c24-fc0dc87d2bfb.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and socialize in our vibrant community lounge, featuring a billiards table, chic seating areas, and unique decor.",
      "link": "false",
      "alt_text": "Stylish community lounge with pool table, comfortable seating, and decorative elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (30).jpg"
    },
    {
      "id": "ec_16ce11332bc8f29a8fec90d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-93ad-757a-b5e2-4dea80ddca07.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with lounge seating and a bar with a TV above a stone fireplace.",
        "public_id": "019d01a1-93ad-757a-b5e2-4dea80ddca07",
        "storage_key": "property/5733056069500928/019d01a1-93ad-757a-b5e2-4dea80ddca07.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax by the resort-style pool, complete with comfortable lounge seating and an outdoor bar area featuring a TV and fireplace.",
      "link": "false",
      "alt_text": "Outdoor pool area with lounge seating and a bar with a TV above a stone fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (31).jpg"
    },
    {
      "id": "ec_56014a8e0c10ebfdc2906c61",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-a11d-704e-95ce-c0b62ccb325f.webp",
      "image_media": {
        "alt_text": "Communal area with a large wooden table, chairs, and a coffee bar.",
        "public_id": "019d01a1-a11d-704e-95ce-c0b62ccb325f",
        "storage_key": "property/5733056069500928/019d01a1-a11d-704e-95ce-c0b62ccb325f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Relax and recharge in our communal lounge area, complete with a convenient coffee bar and comfortable seating.",
      "link": "false",
      "alt_text": "Communal area with a large wooden table, chairs, and a coffee bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (32).jpg"
    },
    {
      "id": "ec_5096acf7ff347ed127c07d68",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-acbb-7559-99a4-b5382cf8b6d3.webp",
      "image_media": {
        "alt_text": "Outdoor dining and lounge area with stone accent wall and 'DINE' signage.",
        "public_id": "019d01a1-acbb-7559-99a4-b5382cf8b6d3",
        "storage_key": "property/5733056069500928/019d01a1-acbb-7559-99a4-b5382cf8b6d3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy our outdoor dining and lounge area, perfect for al fresco meals or relaxing evenings. Features comfortable seating and a stylish stone accent wall with 'DINE' signage.",
      "link": "false",
      "alt_text": "Outdoor dining and lounge area with stone accent wall and 'DINE' signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (33).jpg"
    },
    {
      "id": "ec_955d05f60cc07a1967bc44f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-aa7a-75ee-bd6d-031649bba53d.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table, seating, and bar.",
        "public_id": "019d01a1-aa7a-75ee-bd6d-031649bba53d",
        "storage_key": "property/5733056069500928/019d01a1-aa7a-75ee-bd6d-031649bba53d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in our vibrant community lounge, featuring a pool table, comfortable seating, and a stylish bar area.",
      "link": "false",
      "alt_text": "Community lounge area with a pool table, seating, and bar.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (34).jpg"
    },
    {
      "id": "ec_ff349a2806a36fdb353e4bad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-ab7b-764c-9138-7561df0875c3.webp",
      "image_media": {
        "alt_text": "Modern fitness studio with wood accents, mirrors, and colorful shelves holding exercise balls.",
        "public_id": "019d01a1-ab7b-764c-9138-7561df0875c3",
        "storage_key": "property/5733056069500928/019d01a1-ab7b-764c-9138-7561df0875c3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Experience a vibrant and modern fitness studio designed for your wellness journey. Features include a barre, mirrors, and a well-equipped space for your workouts.",
      "link": "false",
      "alt_text": "Modern fitness studio with wood accents, mirrors, and colorful shelves holding exercise balls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (35).jpg"
    },
    {
      "id": "ec_2c0a07aa97ff1988a0662339",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-b55a-73a7-81d3-17867b393a0d.webp",
      "image_media": {
        "alt_text": "The Enclave apartment building lobby with reception desk and large 'LIVE' decor.",
        "public_id": "019d01a1-b55a-73a7-81d3-17867b393a0d",
        "storage_key": "property/5733056069500928/019d01a1-b55a-73a7-81d3-17867b393a0d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to The Enclave's spacious and modern lobby, featuring a stylish reception area and decorative 'LIVE' signage. Experience the vibrant atmosphere of our community.",
      "link": "false",
      "alt_text": "The Enclave apartment building lobby with reception desk and large 'LIVE' decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (36).jpg"
    },
    {
      "id": "ec_4d8205afd9cda5ef477a5db9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-c1de-764b-a91d-a1edda325592.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019d01a1-c1de-764b-a91d-a1edda325592",
        "storage_key": "property/5733056069500928/019d01a1-c1de-764b-a91d-a1edda325592.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center is equipped with everything you need for a great workout, including cardio machines, weight training equipment, and free weights.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (37).jpg"
    },
    {
      "id": "ec_64c55c772dc0fa734e497c24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-c54c-75e7-9761-8877621880c7.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool and lounge area with apartment buildings in the background.",
        "public_id": "019d01a1-c54c-75e7-9761-8877621880c7",
        "storage_key": "property/5733056069500928/019d01a1-c54c-75e7-9761-8877621880c7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by our sparkling outdoor swimming pool, complete with comfortable lounge seating and cabanas. Our community offers the perfect oasis for unwinding.",
      "link": "false",
      "alt_text": "Resort-style outdoor swimming pool and lounge area with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (38).jpg"
    },
    {
      "id": "ec_4e3f3b39709c9343e7fe512a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a1-c5dd-7519-9e53-06ab04fb6752.webp",
      "image_media": {
        "alt_text": "The Enclave apartment building entrance with stone and gray siding.",
        "public_id": "019d01a1-c5dd-7519-9e53-06ab04fb6752",
        "storage_key": "property/5733056069500928/019d01a1-c5dd-7519-9e53-06ab04fb6752.webp",
        "width": 680,
        "height": 453
      },
      "title": "Community",
      "description": "Welcome to The Enclave, offering modern apartment living with a beautiful exterior and grand entrance.",
      "link": "false",
      "alt_text": "The Enclave apartment building entrance with stone and gray siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/OK_Enclave_at_Brookside_Favorites (39).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f91b0cf0-321e-4d03-b845-0b655933d710",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Nola's ...Creole & Cocktails",
      "poi_type": "Restaurants",
      "poi_address": "1334 E 15th St, Tulsa, OK 74120, USA",
      "poi_short_description": "Casual restaurant offering Cajun fare such as lobster mac 'n' cheese, plus beer, wine, and cocktails.",
      "poi_long_description": "People say this Cajun restaurant serves delicious voodoo chicken, crab cakes, and shrimp and grits. They highlight the fun, New Orleans-inspired atmosphere and the generous portions. They also like the attentive staff and the great happy hour.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5511-7533-b8ba-da36c7af64f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5511-7533-b8ba-da36c7af64f8",
        "storage_key": "property/5733056069500928/019d01a2-5511-7533-b8ba-da36c7af64f8.webp",
        "width": 1280,
        "height": 1218
      },
      "poi_business_url": "http://www.nolastulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=489749569356745618&g_mp=EAAYBCAA",
      "poi_item_slug": "nolas-creole--cocktails",
      "poi_latitude": "36.1400087",
      "poi_longitude": "-95.9748442",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-779-7766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-eba2919e5c07",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ21HLopnstocRkstodqPwywY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_701d7e11-0ec3-4153-8ee0-2f8a6f44b4f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious burgers, pasta, and cheesecake, and offers a wide variety of menu options. They also highlight the large portions, friendly staff, and great atmosphere for date nights and celebrations.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5544-77fa-8a47-5f638ffe8416.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5544-77fa-8a47-5f638ffe8416",
        "storage_key": "property/5733056069500928/019d01a2-5544-77fa-8a47-5f638ffe8416.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=EAAYBCAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-eba2919e5c07",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_22aad23d-cc78-49b6-b420-04711616b204",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Main Event Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "7830 S Santa Fe Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Eatery and entertainment center offering bowling, laser tag, and arcade games.",
      "poi_long_description": "People say this restaurant offers a variety of activities, including bowling, laser tag, and arcade games, and the pizza is awesome. They also highlight the great deals, fun atmosphere, and friendly staff.\n\nOther reviews mention some games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-556c-7069-b8b8-39a9718ff052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-556c-7069-b8b8-39a9718ff052",
        "storage_key": "property/5733056069500928/019d01a2-556c-7069-b8b8-39a9718ff052.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=15664382841071666320&g_mp=EAAYBCAA",
      "poi_item_slug": "main-event-tulsa",
      "poi_latitude": "36.0497894",
      "poi_longitude": "-96.0084228",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-447-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-eba2919e5c07",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM0yApECUtocRkATNUzMRY9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_308905ab-f52a-4b12-8273-42a8c69e5476",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Fast-food chain known for its chicken sandwiches and waffle fries, plus a kids' menu.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-550c-73cf-8d04-c5e130623659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-550c-73cf-8d04-c5e130623659",
        "storage_key": "property/5733056069500928/019d01a2-550c-73cf-8d04-c5e130623659.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=EAAYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-eba2919e5c07",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_968c6f5b-dba7-4f8f-82c6-5f4035fa0c16",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Chain serving chicken fingers alongside crinkle-cut fries, Texas toast, and dipping sauce in a casual setting.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, dipping sauce, and sweet tea. They highlight the fast service and friendly staff. They also like the good value.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5950-77e5-97e1-d77551216d74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5950-77e5-97e1-d77551216d74",
        "storage_key": "property/5733056069500928/019d01a2-5950-77e5-97e1-d77551216d74.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=EAAYBCAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-eba2919e5c07",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-eba2919e5c07.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_b5ba67b9-b431-4010-8e41-85dd5fab31ca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Expansive shopping center with a large selection of stores, a food court, and a carousel.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including a new Scheels with an indoor Ferris wheel, and a great food court. They also highlight the clean, safe, and friendly atmosphere, and the helpful security team.\n\nSome reviews mention the elevators can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5a43-710f-a10c-a87cdb608656.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5a43-710f-a10c-a87cdb608656",
        "storage_key": "property/5733056069500928/019d01a2-5a43-710f-a10c-a87cdb608656.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=EAAYBCAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9050-77a2-a8d6-a8fa48e7ebd3",
        "storage_key": "property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b6860231-0526-45d5-8da7-0db17498d296",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "3702 S Peoria Ave, Tulsa, OK 74105, USA",
      "poi_short_description": "Grocery chain featuring prepared foods, organic products, and specialty items such as wine, cheese, and flowers.",
      "poi_long_description": "People say this grocery store offers a wide variety of unique items, fresh produce, meats, cheeses, and snacks, as well as a great selection of frozen foods, grab-and-go meals, and wine. They highlight the reasonable prices, especially for items like lemon curd and pasta, and the beautiful, well-priced fresh flowers and plants. They also like the friendly, helpful, and polite staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-597f-71ad-aecf-9f85638a12a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-597f-71ad-aecf-9f85638a12a5",
        "storage_key": "property/5733056069500928/019d01a2-597f-71ad-aecf-9f85638a12a5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/tulsa/460/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13583892652892204013&g_mp=EAAYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "36.1096067",
      "poi_longitude": "-95.975934",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-712-9768",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9050-77a2-a8d6-ae5bfafbfcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9050-77a2-a8d6-ae5bfafbfcf0",
        "storage_key": "property/5733056069500928/019d01a2-9050-77a2-a8d6-ae5bfafbfcf0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1TxY2lOTtocR7autsmWug7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7edf1430-3376-4885-9d3d-f2fb4641995a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "901 S Elgin Ave, Tulsa, OK 74120, USA",
      "poi_short_description": "Home improvement chain offering a wide selection of tools, paint, and appliances, plus installation service.",
      "poi_long_description": "People say this home improvement store offers a wide selection of healthy houseplants, including pothos, and a variety of other home improvement products. They also highlight the helpful and knowledgeable staff, and the affordable prices with multiple options.\n\nOther reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-59e4-72c8-9a53-bca8c3e27ebb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-59e4-72c8-9a53-bca8c3e27ebb",
        "storage_key": "property/5733056069500928/019d01a2-59e4-72c8-9a53-bca8c3e27ebb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/North-Tulsa/OK/Tulsa/74120/3904?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9124056414207002316&g_mp=EAAYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.1500127",
      "poi_longitude": "-95.9824315",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-583-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9050-77a2-a8d6-a8fa48e7ebd3",
        "storage_key": "property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbX1Zh33rtocRzMZup_con34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3b5e9bd8-574f-4426-808b-ed46427fd733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Tulsa Hills Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7380 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Bustling shopping mall with a wide variety of big-box stores, restaurants, and gas stations.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and convenient stores. They highlight the convenient location, easy access, and ample parking. They also like the clean and safe environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5e7b-77d3-8326-06251515611d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5e7b-77d3-8326-06251515611d",
        "storage_key": "property/5733056069500928/019d01a2-5e7b-77d3-8326-06251515611d.webp",
        "width": 1280,
        "height": 1027
      },
      "poi_business_url": "http://www.shoptulsahills.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4185409236621719808&g_mp=EAAYBCAA",
      "poi_item_slug": "tulsa-hills-shopping-center",
      "poi_latitude": "36.0563227",
      "poi_longitude": "-96.0033215",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 214-979-3334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9050-77a2-a8d6-a8fa48e7ebd3",
        "storage_key": "property/5733056069500928/019d01a2-9050-77a2-a8d6-a8fa48e7ebd3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5R7A_GeUtocRAPl5hIaPFTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_0380851f-7e7b-44b2-b8af-7275b0841c48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Grocery store chain known for its prices and bulk foods, plus a deli, butcher, and bakery.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, seafood, and bulk items, including candy, nuts, grains, and spices. They highlight the great savings, reasonable prices, and 24/hour availability. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5e85-7456-85cc-8dfc1a89bfa8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5e85-7456-85cc-8dfc1a89bfa8",
        "storage_key": "property/5733056069500928/019d01a2-5e85-7456-85cc-8dfc1a89bfa8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=EAAYBCAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9050-77a2-a8d6-ae5bfafbfcf0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9050-77a2-a8d6-ae5bfafbfcf0",
        "storage_key": "property/5733056069500928/019d01a2-9050-77a2-a8d6-ae5bfafbfcf0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_82d1d203-a165-4025-8356-786daaf689d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5f87-742d-9ffc-1be77978c9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5f87-742d-9ffc-1be77978c9ca",
        "storage_key": "property/5733056069500928/019d01a2-5f87-742d-9ffc-1be77978c9ca.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=EAAYBCAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-edfb500abe48",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_dcee9ed3-24a0-437a-be17-9e2517a999ad",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-5fce-7299-9067-43f8b685bf6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-5fce-7299-9067-43f8b685bf6d",
        "storage_key": "property/5733056069500928/019d01a2-5fce-7299-9067-43f8b685bf6d.webp",
        "width": 1280,
        "height": 743
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=EAAYBCAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-edfb500abe48",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_0b26d22a-164f-4779-a8a7-0f5194caa2c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Tulsa Community College Metro Campus",
      "poi_type": "Education",
      "poi_address": "909 S Boston Ave, Tulsa, OK 74119, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6486-752b-9b8e-de33ab1cffc9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6486-752b-9b8e-de33ab1cffc9",
        "storage_key": "property/5733056069500928/019d01a2-6486-752b-9b8e-de33ab1cffc9.webp",
        "width": 640,
        "height": 512
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7045218815931457502&g_mp=EAAYBCAA",
      "poi_item_slug": "tulsa-community-college-metro-campus",
      "poi_latitude": "36.1478263",
      "poi_longitude": "-95.9864971",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-edfb500abe48",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl_zJWKWStocR3h9-mC-lxWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a3ffc094-6418-4b42-b735-0e498bc1eedc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Tulsa City County Library",
      "poi_type": "Education",
      "poi_address": "400 Civic Center, Tulsa, OK 74103, USA",
      "poi_short_description": "Public library with a large-print section and a play area, plus DVDs and events.",
      "poi_long_description": "People say this public library offers an endless supply of books, computers, and resources, including a recording studio, creation lab, and private rooms. They also highlight the clean, organized, and secure environment, as well as the helpful, friendly, and knowledgeable staff.\n\nOther reviews mention the parking can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-64ee-735f-aab6-06732cacf2b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-64ee-735f-aab6-06732cacf2b0",
        "storage_key": "property/5733056069500928/019d01a2-64ee-735f-aab6-06732cacf2b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.tulsalibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17224735531356744986&g_mp=EAAYBCAA",
      "poi_item_slug": "tulsa-city-county-library",
      "poi_latitude": "36.1505024",
      "poi_longitude": "-95.9941038",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-edfb500abe48",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXavXrXDrtocRGm2RiLSNCu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_f51da657-6da6-4855-8ab3-688e50eb658b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Oklahoma State University-Tulsa",
      "poi_type": "Education",
      "poi_address": "700 N Greenwood Ave, Tulsa, OK 74106, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6553-722d-8f54-e658c850a594.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6553-722d-8f54-e658c850a594",
        "storage_key": "property/5733056069500928/019d01a2-6553-722d-8f54-e658c850a594.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.okstate.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15418720188867322820&g_mp=EAAYBCAA",
      "poi_item_slug": "oklahoma-state-university-tulsa",
      "poi_latitude": "36.1638478",
      "poi_longitude": "-95.9880553",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-594-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9057-73c8-9309-edfb500abe48",
        "storage_key": "property/5733056069500928/019d01a2-9057-73c8-9309-edfb500abe48.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa2utZoTrtocRxKOU5FFM-tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5cba48f9-aaff-4c04-84c8-84545c42c946",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "BOK Center",
      "poi_type": "Entertainment",
      "poi_address": "200 S Denver Ave., Tulsa, OK 74103, USA",
      "poi_short_description": "Venue hosting a wide range of events, from concerts by major artists to sporting events.",
      "poi_long_description": "People say this arena offers a variety of events, including concerts and hockey games. They highlight the easy access, convenient parking, and clean facilities. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-65b0-7779-8006-15dec2e1fa58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-65b0-7779-8006-15dec2e1fa58",
        "storage_key": "property/5733056069500928/019d01a2-65b0-7779-8006-15dec2e1fa58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bokcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13467435354223455802&g_mp=EAAYBCAA",
      "poi_item_slug": "bok-center",
      "poi_latitude": "36.1527447",
      "poi_longitude": "-95.9963597",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-894-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ966yH3frtocROq4G5Bnx5bo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_023f6512-d41e-455c-a86b-1b85274755b4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Home to the world's largest bull shark exhibit, this aquarium also has touch tanks, otters, and a carousel.",
      "poi_long_description": "People say this aquarium offers a variety of sea life, including bull sharks, a giant sea turtle, and an octopus, as well as interactive touch pools and feeding experiences. They highlight the shark tunnel, the carousel, and the family-friendly atmosphere. They also like the clean facility and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6957-72cd-8ce3-09c3c249bdff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6957-72cd-8ce3-09c3c249bdff",
        "storage_key": "property/5733056069500928/019d01a2-6957-72cd-8ce3-09c3c249bdff.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=EAAYBCAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_21ae410a-f2cd-4f11-91c2-767c272960d6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Philbrook Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2727 S Rockford Rd, Tulsa, OK 74114, USA",
      "poi_short_description": "Historic home and grounds with a collection of art from around the world, plus a restaurant.",
      "poi_long_description": "People say this museum offers a diverse art collection, including traditional and modern pieces, and a beautiful garden with flowing water and serene spaces. They highlight the stunning architecture of the mansion, the well-maintained grounds, and the immersive Samurai exhibit. They also like the friendly and helpful staff, and the various events and activities for families and children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6abe-728e-a36e-16f984bf4c21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6abe-728e-a36e-16f984bf4c21",
        "storage_key": "property/5733056069500928/019d01a2-6abe-728e-a36e-16f984bf4c21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.philbrook.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1301074669923315730&g_mp=EAAYBCAA",
      "poi_item_slug": "philbrook-museum-of-art",
      "poi_latitude": "36.1238549",
      "poi_longitude": "-95.9700944",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-749-7941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93ad-76b3-8e86-11304e8dcb1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93ad-76b3-8e86-11304e8dcb1c",
        "storage_key": "property/5733056069500928/019d01a2-93ad-76b3-8e86-11304e8dcb1c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VsvX7DstocRErAJ14RYDhI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1e61da5d-df91-4311-bac6-8820b8fe257e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Kid-friendly recreation center with exhibits and a splash pad, plus live performances, and a cafe.",
      "poi_long_description": "People say this children's museum offers a wide variety of engaging and educational exhibits and activities for children of all ages, including a giant sand pit, building blocks, and interactive science exhibits. They highlight the fun, hands-on learning opportunities, and the spacious, accessible layout that allows parents to easily navigate with strollers. They also like the friendly and helpful staff, and the clean, well-maintained facility.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6aa4-74ad-9074-63c6546780e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6aa4-74ad-9074-63c6546780e5",
        "storage_key": "property/5733056069500928/019d01a2-6aa4-74ad-9074-63c6546780e5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=EAAYBCAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93ad-76b3-8e86-11304e8dcb1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93ad-76b3-8e86-11304e8dcb1c",
        "storage_key": "property/5733056069500928/019d01a2-93ad-76b3-8e86-11304e8dcb1c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_16834e91-f13e-4c3c-b1cb-4211cf482b7a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "ONEOK Field",
      "poi_type": "Entertainment",
      "poi_address": "201 N Elgin Ave, Tulsa, OK 74120, USA",
      "poi_short_description": "Double-A affiliate of the Los Angeles Dodgers plays home games at this modern ballpark.",
      "poi_long_description": "People say this ballpark offers exciting baseball games and impressive fireworks displays. They highlight the fun, family-friendly atmosphere and the clean, well-maintained facilities. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6b92-7729-b501-1f21edd68405.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6b92-7729-b501-1f21edd68405",
        "storage_key": "property/5733056069500928/019d01a2-6b92-7729-b501-1f21edd68405.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.milb.com/tulsa/ballpark/oneok-field",
      "poi_directions_map_url": "https://maps.google.com/?cid=1807922863200646080&g_mp=EAAYBCAA",
      "poi_item_slug": "oneok-field",
      "poi_latitude": "36.1603586",
      "poi_longitude": "-95.9878439",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-744-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93c1-727b-9fbe-4a10c6dd2bfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93c1-727b-9fbe-4a10c6dd2bfc",
        "storage_key": "property/5733056069500928/019d01a2-93c1-727b-9fbe-4a10c6dd2bfc.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDf8s0arrtocRwLNh6kMIFxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_ae9e14bb-98bd-4f56-b658-4dfdb1a51735",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5313 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Chain gym with tanning beds and massage chairs offering memberships.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6e75-7659-b5c3-574fe62efca0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6e75-7659-b5c3-574fe62efca0",
        "storage_key": "property/5733056069500928/019d01a2-6e75-7659-b5c3-574fe62efca0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/tulsa-e-41st-st-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=13083138713911034027&g_mp=EAAYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.1059581",
      "poi_longitude": "-95.9165485",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-238-1890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYDkNm-NtocRqwDUxVelkLU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_53a6d26d-5bb4-4542-8ec5-56a8a6011496",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Oklahoma Veterinary Specialists",
      "poi_type": "Health and Wellness",
      "poi_address": "1501 West 78th Street South, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-6f53-731c-9bba-b614139232c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-6f53-731c-9bba-b614139232c5",
        "storage_key": "property/5733056069500928/019d01a2-6f53-731c-9bba-b614139232c5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "http://okvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5093478136724344104&g_mp=EAAYBCAA",
      "poi_item_slug": "oklahoma-veterinary-specialists",
      "poi_latitude": "36.0519175",
      "poi_longitude": "-96.0079484",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-299-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn8o0AyeUtocRKE2sAmGrr0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_720ac363-bebc-4762-bdc6-8e3d81b47907",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "4818 E 80th St Ste A, Tulsa, OK 74136, USA",
      "poi_short_description": "Gym offering cardio and strength equipment, plus Pilates, yoga, tanning, and personal training.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment, including free weights, machines, and a sauna. They highlight the clean facilities, spacious layout, and welcoming atmosphere, with people from all walks of life enjoying their workouts. They also like the friendly, knowledgeable, and helpful staff, and the range of fitness classes available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7374-7269-9d22-34f6719abcf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7374-7269-9d22-34f6719abcf5",
        "storage_key": "property/5733056069500928/019d01a2-7374-7269-9d22-34f6719abcf5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://10gym.com/south-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2406416433432823692&g_mp=EAAYBCAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.047648",
      "poi_longitude": "-95.9239656",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-494-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6-ITWKKTtocRjAdtGP9OZSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a67e4a19-6d3c-4639-ad6d-5c7453ecd865",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Contemporary salon offering hair coloring, cutting, and styling services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-73d9-75a9-8b33-effc47169d94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-73d9-75a9-8b33-effc47169d94",
        "storage_key": "property/5733056069500928/019d01a2-73d9-75a9-8b33-effc47169d94.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=EAAYBCAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_b4954dbe-4412-4686-ab4a-ad1c10aaf7a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Midtown Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "4103 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Gym featuring state-of-the-art equipment, a variety of classes, childcare, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of weight machines, free weights, and cardio equipment, as well as amenities like a steam room, sauna, and rock wall. They highlight the clean facilities, convenient location, and friendly staff. They also like the protein shakes and smoothies available at the bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-74af-7214-8e5e-1cef97056229.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-74af-7214-8e5e-1cef97056229",
        "storage_key": "property/5733056069500928/019d01a2-74af-7214-8e5e-1cef97056229.webp",
        "width": 619,
        "height": 348
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/midtown-tulsa.html?utm_campaign=search&utm_medium=organic&utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9719539965655344511&g_mp=EAAYBCAA",
      "poi_item_slug": "genesis-health-clubs---midtown-tulsa",
      "poi_latitude": "36.1023537",
      "poi_longitude": "-95.9210055",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-641-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRwPcrceStocRf2UZORq-4oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8cd4204f-130c-4afc-b50d-6e55f81333b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Animal Emergency Center of Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "4055 S 102nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7812-77ef-8872-39905f2b2413.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7812-77ef-8872-39905f2b2413",
        "storage_key": "property/5733056069500928/019d01a2-7812-77ef-8872-39905f2b2413.webp",
        "width": 1060,
        "height": 596
      },
      "poi_business_url": "https://aectulsa.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb&utm_term=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=5673475209959077837&g_mp=EAAYBCAA",
      "poi_item_slug": "animal-emergency-center-of-tulsa",
      "poi_latitude": "36.1054336",
      "poi_longitude": "-95.8632907",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-665-0508",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_xcYAlmNtocRzXeY46Q7vE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_cf5bcf9d-dac6-4514-8ec9-0a07548ea41b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Elephant In The Room Men's Grooming Lounge of Downtown Tulsa Men's Haircuts",
      "poi_type": "Health and Wellness",
      "poi_address": "1730 S Boston Ave suite a, Tulsa, OK 74119, USA",
      "poi_short_description": "Barbershop specializing in modern men's haircuts and grooming services in a relaxing environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-798e-732b-b001-4d155f458827.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-798e-732b-b001-4d155f458827",
        "storage_key": "property/5733056069500928/019d01a2-798e-732b-b001-4d155f458827.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://eitrlounge.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12678830938661803288&g_mp=EAAYBCAA",
      "poi_item_slug": "elephant-in-the-room-mens-grooming-lounge-of-downtown-tulsa-mens-haircuts",
      "poi_latitude": "36.1368371",
      "poi_longitude": "-95.9854917",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-877-2219",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfyMP9JTrtocRGFUrOpBB9K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_4271a2d5-1e03-4673-a37d-075ff5141d94",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-78ac-70dd-9549-a3a71b183410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-78ac-70dd-9549-a3a71b183410",
        "storage_key": "property/5733056069500928/019d01a2-78ac-70dd-9549-a3a71b183410.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=EAAYBCAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93c1-727b-9fbe-4d77d10884ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93c1-727b-9fbe-4d77d10884ae",
        "storage_key": "property/5733056069500928/019d01a2-93c1-727b-9fbe-4d77d10884ae.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_60b8ecef-ef28-43fd-9b9c-3a9079c5e88f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Ascension St. John Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1923 S Utica Ave, Tulsa, OK 74104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-78af-70eb-a167-13f2236d7ca3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-78af-70eb-a167-13f2236d7ca3",
        "storage_key": "property/5733056069500928/019d01a2-78af-70eb-a167-13f2236d7ca3.webp",
        "width": 512,
        "height": 512
      },
      "poi_business_url": "https://healthcare.ascension.org/locations/oklahoma/oktul/tulsa-ascension-st-john-medical-center?utm_campaign=gmb&utm_medium=organic&utm_source=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615004765601411578&g_mp=EAAYBCAA",
      "poi_item_slug": "ascension-st-john-medical-center",
      "poi_latitude": "36.1341017",
      "poi_longitude": "-95.9666058",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-744-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93c1-727b-9fbe-4d77d10884ae.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93c1-727b-9fbe-4d77d10884ae",
        "storage_key": "property/5733056069500928/019d01a2-93c1-727b-9fbe-4d77d10884ae.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0zInA23ttocR-jEY481alOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d60659da-bb64-494e-8801-e5c29ced50a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Gathering Place",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2650 S John Williams Way, Tulsa, OK 74114, USA",
      "poi_short_description": "Riverfront park with interactive play elements, picnic tables, and a skateboard area, plus food trucks.",
      "poi_long_description": "People say this park offers a variety of activities, including playgrounds, walking trails, kayaking, and a skate park. They highlight the beautiful landscaping, peaceful atmosphere, and family-friendly vibe. They also like the clean facilities and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7d4f-741b-b578-dc5571160d8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7d4f-741b-b578-dc5571160d8d",
        "storage_key": "property/5733056069500928/019d01a2-7d4f-741b-b578-dc5571160d8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gatheringplace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14222367875341211287&g_mp=EAAYBCAA",
      "poi_item_slug": "gathering-place",
      "poi_latitude": "36.1251603",
      "poi_longitude": "-95.9840207",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-779-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9767-74ee-a15b-c4a5b377a326",
        "storage_key": "property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrYnn1dDttocRl9ajsjoAYMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6691a2ca-388e-4077-9870-5c10c7c099cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Woodward Park and Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2435 S Peoria Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Parklike setting with a 1919 Italian Renaissance-style home and a rose garden, plus playgrounds and walking paths.",
      "poi_long_description": "People say this park offers beautiful gardens, a variety of plants and flowers, and plenty of photo opportunities. They highlight the peaceful and relaxing vibe, and the abundance of squirrels. They also like the ample picnic spots, benches, and swings. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7d0f-7071-bb5f-4dafae462d79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7d0f-7071-bb5f-4dafae462d79",
        "storage_key": "property/5733056069500928/019d01a2-7d0f-7071-bb5f-4dafae462d79.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.tulsagardencenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12962617171359971077&g_mp=EAAYBCAA",
      "poi_item_slug": "woodward-park-and-gardens",
      "poi_latitude": "36.1319247",
      "poi_longitude": "-95.9736606",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-576-5155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9767-74ee-a15b-c4a5b377a326",
        "storage_key": "property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJr8FnRKPstocRBTdKcqN35LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_73f157b4-c7fc-4aba-8db4-e0834452d959",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Chandler Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6500 W 21st St, Tulsa, OK 74107, USA",
      "poi_short_description": "Wooded area offering disc golf, rock climbing, trails, a splash park, a community center, and athletic fields.",
      "poi_long_description": "People say this park offers great hiking trails with scenic views of limestone bluffs and cliffs, and a fun splash pad and playground for kids. They highlight the affordable entry fee for the splash pad and the clean, well-maintained grounds. They also like the interesting historical information available throughout the park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7e9c-77b9-b749-af5bd7c13f80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7e9c-77b9-b749-af5bd7c13f80",
        "storage_key": "property/5733056069500928/019d01a2-7e9c-77b9-b749-af5bd7c13f80.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/chandler-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17536025104603203220&g_mp=EAAYBCAA",
      "poi_item_slug": "chandler-park",
      "poi_latitude": "36.1330488",
      "poi_longitude": "-96.0674392",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-591-6053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9767-74ee-a15b-c4a5b377a326",
        "storage_key": "property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_StqBp_qtocRlMY0POx5XPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c7b6c94d-6613-412a-bb08-e2253c838c03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Midtown green space with an 18-hole championship golf course, tennis center, and 5k trail, plus playgrounds and a pond.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, picnic areas, and a walking trail. They highlight the park is beautiful, well-maintained, and family-friendly, with a quiet and peaceful vibe. They also like the friendly and professional staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-7e85-71ee-8ffc-ee3ba954e064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-7e85-71ee-8ffc-ee3ba954e064",
        "storage_key": "property/5733056069500928/019d01a2-7e85-71ee-8ffc-ee3ba954e064.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=EAAYBCAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9767-74ee-a15b-c4a5b377a326",
        "storage_key": "property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_91f042db-dc50-4717-a379-2ed34e7f6626",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Guthrie Green",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "111 Reconciliation Way, Tulsa, OK 74103, USA",
      "poi_short_description": "Public park featuring picnic tables and a calendar of events including concerts, movies, and yoga classes.",
      "poi_long_description": "Concerts, festivals, green markets, fitness classes, a sleek cafe & more in an urban park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-81f2-73db-aa26-4d6ad2f29a3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-81f2-73db-aa26-4d6ad2f29a3a",
        "storage_key": "property/5733056069500928/019d01a2-81f2-73db-aa26-4d6ad2f29a3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.guthriegreen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9339549307871769339&g_mp=EAAYBCAA",
      "poi_item_slug": "guthrie-green",
      "poi_latitude": "36.1597162",
      "poi_longitude": "-95.9920028",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-574-2421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-9767-74ee-a15b-c4a5b377a326",
        "storage_key": "property/5733056069500928/019d01a2-9767-74ee-a15b-c4a5b377a326.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSYk4oLrtocR-zLxyZy-nIE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_79d1728b-ea95-467f-9974-c41e471103ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Tulsa Riverside Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "8605 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-83fb-7709-b4b9-b40cdc84cc0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-83fb-7709-b4b9-b40cdc84cc0f",
        "storage_key": "property/5733056069500928/019d01a2-83fb-7709-b4b9-b40cdc84cc0f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flytulsa.com/tulsa-river-side/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10887194896589047936&g_mp=EAAYBCAA",
      "poi_item_slug": "tulsa-riverside-airport",
      "poi_latitude": "36.0378532",
      "poi_longitude": "-95.9909439",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-299-5886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-97ac-73d0-b242-dfec1589dbce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-97ac-73d0-b242-dfec1589dbce",
        "storage_key": "property/5733056069500928/019d01a2-97ac-73d0-b242-dfec1589dbce.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJG-5WQAiUtocRgMiiWxMWF5c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_226e26c6-3118-470f-adb2-9a8ae1ed51aa",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Christiansen Aviation",
      "poi_type": "Transportation & Transit",
      "poi_address": "8767 S Jack Bates Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-8315-748f-84dd-dae1e2bc2fd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-8315-748f-84dd-dae1e2bc2fd2",
        "storage_key": "property/5733056069500928/019d01a2-8315-748f-84dd-dae1e2bc2fd2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://christiansenaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11204997232924193680&g_mp=EAAYBCAA",
      "poi_item_slug": "christiansen-aviation",
      "poi_latitude": "36.0365935",
      "poi_longitude": "-95.9895957",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-299-2646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-97ac-73d0-b242-dfec1589dbce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-97ac-73d0-b242-dfec1589dbce",
        "storage_key": "property/5733056069500928/019d01a2-97ac-73d0-b242-dfec1589dbce.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1SWkpQWUtocRkHOu4Z0lgJs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_9716923d-a626-4604-8b9a-c9e5f76fcf3b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-84b5-718b-937c-80020a54eac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-84b5-718b-937c-80020a54eac5",
        "storage_key": "property/5733056069500928/019d01a2-84b5-718b-937c-80020a54eac5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=EAAYBCAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_26a2579a-b98d-4a56-a39f-f58b8b9fc5de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "One Williams Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "E 2nd St S, Tulsa, OK 74103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-867e-7568-b21f-1728974a8afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-867e-7568-b21f-1728974a8afe",
        "storage_key": "property/5733056069500928/019d01a2-867e-7568-b21f-1728974a8afe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.williams.com/one-williams-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11130102491191827&g_mp=EAAYBCAA",
      "poi_item_slug": "one-williams-center",
      "poi_latitude": "36.1549519",
      "poi_longitude": "-95.9905266",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9bY73jrtocRExpN7cSKJwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_708178ef-1f7f-45e5-8bf8-2fcb6e797c71",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Tulsa City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "175 E 2nd St S, Tulsa, OK 74103, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-88ed-73ee-9e94-9b18c5f21678.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-88ed-73ee-9e94-9b18c5f21678",
        "storage_key": "property/5733056069500928/019d01a2-88ed-73ee-9e94-9b18c5f21678.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.cityoftulsa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16002390370713188289&g_mp=EAAYBCAA",
      "poi_item_slug": "tulsa-city-hall",
      "poi_latitude": "36.1551979",
      "poi_longitude": "-95.9895483",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-596-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-97ac-73d0-b242-d822e6061992.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-97ac-73d0-b242-d822e6061992",
        "storage_key": "property/5733056069500928/019d01a2-97ac-73d0-b242-d822e6061992.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK4IT5XjrtocRwbd9A0LpE94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_9edc7d0c-658b-43b7-bd80-621c58748b9a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "BOK Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 One Williams Center, Tulsa, OK 74172, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-8a5c-7316-b4de-306c293ea647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d01a2-8a5c-7316-b4de-306c293ea647",
        "storage_key": "property/5733056069500928/019d01a2-8a5c-7316-b4de-306c293ea647.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2178592993897759726&g_mp=EAAYBCAA",
      "poi_item_slug": "bok-tower",
      "poi_latitude": "36.1550178",
      "poi_longitude": "-95.9903034",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeSUc73jrtocR7kNuB8nqOx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6528e81c-a775-4db6-af81-53219ad1d30a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=EAAYBCAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d01a2-93b6-70be-abc6-59ec7ab94863",
        "storage_key": "property/5733056069500928/019d01a2-93b6-70be-abc6-59ec7ab94863.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_298069796e5ea6c1affbe719",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "WED",
      "open_time": "10:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f6e4fb0c7bed2b679a9bd5c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e7430159d7676034c64ca9a2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f437f9ea4c782b25c1d295c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_303d664bfa97776796ea2dc7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_40de53b7153c4449c9f05e93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_3942dd73c9cf8979f934c01c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "rating": "5",
      "name": "Jason Meisner",
      "text": "The whole team has been fantastic. Just moved across the country and it’s always scary going to a new place.  The leasing team did an amazing job and has been so helpful even after the move and Joel in maintenance is one of the nicest most sincere people I’ve met who went above and beyond and is a true asset.  Cassidy and Brenda in the office have been doing the work behind the scenes and are all so nice. Amazing location. Great area.  Clean and safe community and looking forward to the next year here!",
      "date": "2026-06-05",
      "title": "false"
    },
    {
      "id": "ec_e6cef2fb339ceacce68a411f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "rating": "5",
      "name": "Jennifer Lane",
      "text": "Such a Gorgeous apartment complex! As a dasher & needing help with directions, Joel with maintenance,  generously provided me with directions & even walked me to the apartment I was delivering to. He is  one of the kindest, most helpful people I’ve met.  I am very thankful for his help & hospitality. We need more people in this world like Joel!!  ⭐️ ⭐️ ⭐️ ⭐️ ⭐️ ~ definitely 💯!",
      "date": "2026-06-24",
      "title": "false"
    },
    {
      "id": "ec_f537567eb3445daeb84925f5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "rating": "5",
      "name": "Kristen Caldwell",
      "text": "Enclave is a great place to live. The ambiance is unbeatable. Also, it’s super close to all the restaurant/ and grocery stores in Brookside. Maintenance (Ramon) is quick with issues and Joel has done a wrongful job with maintaining around the pool area. We have a great maintenance team!",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_68640e3dcbd7bb3ecc1f1b7b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "rating": "5",
      "name": "Elon Floyd",
      "text": "We didn't end up leasing here, but it was our top second choice all things considered. It has really nice amenities and everything was very clean. Cassidy was awesome and showed us a number of unit options. Thank you Cassidy for your very friendly and professional manner!",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_5f3358d792e28891066e1452",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "rating": "5",
      "name": "Suzanne Burrow",
      "text": "Just renewed my lease for the 12th time at The Enclave at Brookside. I’m one of the original tenants and I love living here! The neighborhood has everything I need! And Charles is AMAZING! He’s new to the property but he’s been in the business for 25 years and knows a lot about customer service and how to make you feel special! If you’re looking for a unique and classy place that’s also safe to call home …. choose The Enclave at Brookside!",
      "date": "2026-04-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_dad01d8b9c18dc66ccc322f1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/01a03ef1-50ec-724e-ba47-58ba750ab1b8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03ef1-50ec-724e-ba47-58ba750ab1b8",
        "storage_key": "property/5733056069500928/01a03ef1-50ec-724e-ba47-58ba750ab1b8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ADxPFBBZiSM&back=1"
    },
    {
      "id": "ec_28c6b57d40d59e8c4117f9c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/01a03ef1-5578-70af-9e76-e9f0efbf2ef1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03ef1-5578-70af-9e76-e9f0efbf2ef1",
        "storage_key": "property/5733056069500928/01a03ef1-5578-70af-9e76-e9f0efbf2ef1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Play Room",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=aYRfYcUqCfN"
    },
    {
      "id": "ec_e2a093769ebf5e8e1192fd1f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019ddcc6-aff8-7112-ac90-ff22f8906b41.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc6-aff8-7112-ac90-ff22f8906b41",
        "storage_key": "property/5733056069500928/019ddcc6-aff8-7112-ac90-ff22f8906b41.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Alta",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DqzmoXkTeYR"
    },
    {
      "id": "ec_cfe6ef59fceaa0acd5275467",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/01a03ef1-6d50-76e9-b0b6-3e7b1528aabf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a03ef1-6d50-76e9-b0b6-3e7b1528aabf",
        "storage_key": "property/5733056069500928/01a03ef1-6d50-76e9-b0b6-3e7b1528aabf.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - Vogue",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=jBkR9Gd2sB6"
    },
    {
      "id": "ec_1d60e491b41068d45ea80a5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019ddcc6-afc5-7644-afbd-7449278a7065.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc6-afc5-7644-afbd-7449278a7065",
        "storage_key": "property/5733056069500928/019ddcc6-afc5-7644-afbd-7449278a7065.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - Nuvo",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=H4DXpqo9SBA"
    },
    {
      "id": "ec_39fdeac74da068b710c1ce2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019ddcc6-b050-755e-84a1-e56a8ca90c00.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019ddcc6-b050-755e-84a1-e56a8ca90c00",
        "storage_key": "property/5733056069500928/019ddcc6-b050-755e-84a1-e56a8ca90c00.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA-Panorama/1510SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PEy7kwPCDYb"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-5dae-70d9-b6ac-b4b51daf237d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "the-enclave-at-brookside",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928"
    },
    {
      "lead_collector_id": "0198aa47-5e11-700f-9532-f47803ddf3eb",
      "lead_source": "FACEBOOK_ADS",
      "name": "the-enclave-at-brookside",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928"
    },
    {
      "lead_collector_id": "0198aa47-5e72-70ff-97a3-0b23ce8f8da2",
      "lead_source": "LANDING_PAGE",
      "name": "the-enclave-at-brookside",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-with-pool-tulsa-ok-the-enclave-brookside",
      "search_query": "apartments with pool Tulsa OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Tulsa, OK",
      "h2_subtitle": "Discover our apartments with a pool in Tulsa, OK. Dive into tranquility at The Enclave at Brookside.",
      "page_copy": "Welcome to The Enclave at Brookside, where modern living meets relaxation. Our Tulsa apartments offer a refreshing pool for leisurely swims, perfect for unwinding after a long day. Experience top-notch amenities, including a yoga studio and game room, providing endless options for recreation and relaxation. \n\nLocated in the heart of Tulsa, our one and two-bedroom layouts are designed for comfort and style. Enjoy ceiling fans, a pet-friendly atmosphere with a dedicated dog park, and a community that puts leisure first. Schedule a tour today to explore The Enclave and see why our pool is just the beginning of a luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Top Apartments with Pool in Tulsa, OK",
      "seo_description": "Experience the best of Tulsa living at The Enclave with a pool, yoga studio, and more. Schedule a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-brookside-tulsa-the-enclave",
      "search_query": "pet friendly apartments Brookside Tulsa",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Brookside Tulsa",
      "h2_subtitle": "Explore our pet friendly apartments in Brookside Tulsa. The Enclave at Brookside welcomes pets with open arms.",
      "page_copy": "Welcome to The Enclave at Brookside, a haven for pet owners in Tulsa. Our pet friendly apartments in Brookside Tulsa feature a dedicated dog park, ensuring your four-legged friends have ample space to play. Enjoy spacious one and two-bedroom units equipped with modern amenities like ceiling fans and a game room.\n\nLocated in the vibrant Brookside neighborhood, The Enclave offers a community that values both you and your pets. Unwind in our yoga studio or lounge by the pool – the perfect retreat after a day at our pet play area. Discover the ideal balance of comfort and convenience in a pet-friendly environment today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Brookside Tulsa",
      "seo_description": "Find pet friendly living at The Enclave in Brookside Tulsa. Enjoy amenities like a dog park, pool, and more. Schedule your visit today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "luxury-apartments-fitness-center-tulsa-the-enclave",
      "search_query": "luxury apartments with fitness center in Tulsa",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Fitness Center Tulsa",
      "h2_subtitle": "Discover luxury apartments with a fitness center in Tulsa. Experience comfort and style at The Enclave at Brookside.",
      "page_copy": "Step into luxury at The Enclave at Brookside, offering premium living with a well-equipped fitness center in Tulsa. Our residents enjoy top-tier amenities, including weight machines and a yoga studio, designed to elevate your wellness routine. Our spacious one and two-bedroom apartments embody modern elegance, providing a perfect blend of comfort and style.\n\nCentrally located, The Enclave offers more than just a place to live; it’s a community focused on a vibrant lifestyle. Along with an inviting pool and game room, you’ll find everything you need to feel at home. Visit us today to see why our fitness center and refined living spaces set the standard for luxury apartments in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Fitness Center in Tulsa",
      "seo_description": "Experience luxury living at The Enclave in Tulsa with a fitness center, pool, and more. Visit us for a tour today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "yoga-studio-apartments-74105-the-enclave-brookside",
      "search_query": "yoga studio apartments 74105",
      "category": "Amenity",
      "h1_title": "Yoga Studio Apartments in 74105",
      "h2_subtitle": "Find apartments with a yoga studio in the 74105 area. The Enclave at Brookside offers wellness-focused living.",
      "page_copy": "Welcome to The Enclave at Brookside, where tranquility meets convenience in the 74105 area. Our apartments feature a dedicated yoga studio, perfect for those who prioritize wellness right at home. With spacious one and two-bedroom options, you'll enjoy other amenities like a refreshing pool and a fun game room.\n\nLocated in a prime Tulsa neighborhood, our community extends beyond physical wellness with pet-friendly facilities including a dog park. Experience modern living intertwined with harmony and leisure. Schedule a tour today to explore our unique offerings and see why residents choose The Enclave for their ideal home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yoga Studio Apartments in 74105",
      "seo_description": "Discover apartments with a yoga studio in the 74105 area at The Enclave. Enjoy amenities like a pool and pet park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "dog-park-apartments-near-brookside-the-enclave",
      "search_query": "dog park apartments near Brookside",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near Brookside",
      "h2_subtitle": "Discover apartments with a dog park near Brookside at The Enclave. Your pets will love our expansive pet play area.",
      "page_copy": "The Enclave at Brookside invites you and your furry friends to a community designed with pets in mind. Our apartments, conveniently located near Brookside, feature a dedicated dog park where your pets can roam and play freely. Choose from our spacious one and two-bedroom residences that blend modern comforts with pet-friendly living.\n\nIn addition to the dog park, residents enjoy diverse amenities such as a yoga studio, invigorating pool, and game room. This vibrant community embraces a pet-friendly lifestyle, ensuring that both you and your pets feel right at home. For those seeking a balanced lifestyle with their four-legged companions, The Enclave is the place to be.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near Brookside",
      "seo_description": "Explore The Enclave near Brookside. Enjoy apartments with a dog park, game room, and more. Perfect for pet owners.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-brookside-tulsa-the-enclave",
      "search_query": "one bedroom apartments brookside tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Brookside Tulsa",
      "h2_subtitle": "Explore one bedroom apartments in Brookside, Tulsa. The Enclave at Brookside offers the perfect urban retreat.",
      "page_copy": "Discover the ideal one bedroom apartment at The Enclave at Brookside in Tulsa. Nestled in the vibrant Brookside neighborhood, our apartments provide a perfect blend of modern style and comfort. Each one bedroom home offers spacious layouts and contemporary finishes designed for convenient living.\n\nEnjoy an array of amenities that enhance your lifestyle, including a relaxing pool, a state-of-the-art yoga studio, and a bustling game room. With a dog park on-site, you’ll also find our community welcoming to pets. Experience the allure of Brookside living with all the comforts you desire at The Enclave.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Brookside Tulsa",
      "seo_description": "Find one bedroom apartments in Brookside, Tulsa at The Enclave. Enjoy modern living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-74105-the-enclave",
      "search_query": "two bedroom apartments near 74105",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 74105",
      "h2_subtitle": "Discover two bedroom apartments near the 74105 area at The Enclave. Modern living with ample amenities awaits you.",
      "page_copy": "Welcome to The Enclave at Brookside, offering spacious two bedroom apartments conveniently located near the 74105 area in Tulsa. Our well-appointed residences provide ample living space and contemporary designs, perfect for those seeking a balance of comfort and style.\n\nResidents enjoy access to a wealth of amenities, including a refreshing pool, a dedicated yoga studio, and an entertaining game room. For pet owners, our community features a dog park where your pets can play freely. Embrace the ideal blend of modern living and community convenience at The Enclave, your new home away from home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 74105",
      "seo_description": "Explore two bedroom apartments near 74105 at The Enclave. Enjoy comfortable living with top amenities in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa-the-enclave",
      "search_query": "apartments near Oral Roberts University Tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University Tulsa",
      "h2_subtitle": "Find comfortable apartments near Oral Roberts University in Tulsa. The Enclave offers modern living just a short drive away.",
      "page_copy": "The Enclave at Brookside presents a fantastic living option for students and faculty seeking apartments near Oral Roberts University in Tulsa. Our community offers a range of one and two-bedroom layouts designed for those who want both convenience and style.\n\nLocated within easy access to the university, The Enclave provides all the modern amenities you need, such as a refreshing pool, a fully-equipped game room, and a serene yoga studio. With a dedicated dog park, the community is also extremely pet-friendly. Discover a harmonious blend of modern comfort and proximity at The Enclave, your ideal home near campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University Tulsa",
      "seo_description": "Discover apartments near Oral Roberts University in Tulsa. The Enclave offers luxury living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "enclave-at-brookside-near-university-of-tulsa",
      "search_query": "The Enclave at Brookside near The University of Tulsa",
      "category": "School",
      "h1_title": "The Enclave at Brookside Near University of Tulsa",
      "h2_subtitle": "Discover The Enclave at Brookside, located near The University of Tulsa. A modern living haven awaits you.",
      "page_copy": "The Enclave at Brookside is the perfect choice for those seeking a stylish and comfortable home near The University of Tulsa. Offering a variety of one and two-bedroom apartments, our community is designed with the modern resident in mind.\n\nConveniently situated, The Enclave provides quick access to campus while offering a host of attractive amenities. Residents can enjoy on-site features like a peaceful yoga studio, an engaging game room, and a dog park ideal for pet lovers. Embrace a welcoming environment and convenient location at The Enclave, making it an excellent choice for students and staff alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Enclave at Brookside Near University of Tulsa",
      "seo_description": "The Enclave at Brookside offers proximity to The University of Tulsa with modern amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-close-to-tulsa-community-college-metro-campus",
      "search_query": "apartments close to Tulsa Community College Metro Campus OK",
      "category": "School",
      "h1_title": "Apartments Close to Tulsa Community College Metro Campus",
      "h2_subtitle": "Find ideal apartments close to Tulsa Community College Metro Campus. Enjoy modern amenities and convenience at The Enclave.",
      "page_copy": "Located near the Tulsa Community College Metro Campus, The Enclave at Brookside offers an ideal living solution for students and staff seeking apartments within easy reach of campus. Our community features spacious one and two-bedroom floor plans that combine comfort and modern design.\n\nThe Enclave comes equipped with outstanding amenities, including a yoga studio, games room, and a refreshing pool. Residents can also enjoy our pet-friendly dog park. Here, you'll find all the comforts of home with the added convenience of being just a short commute from the Metro Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Tulsa Community College Metro Campus",
      "seo_description": "Discover apartments close to Tulsa Community College Metro Campus at The Enclave, offering modern living and convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "rentals-by-oklahoma-state-university-tulsa-74105",
      "search_query": "rentals by Oklahoma State University-Tulsa 74105",
      "category": "School",
      "h1_title": "Rentals by Oklahoma State University-Tulsa",
      "h2_subtitle": "Explore rentals by Oklahoma State University-Tulsa in the 74105 area. The Enclave offers the perfect solution for students and staff.",
      "page_copy": "Conveniently located rentals by Oklahoma State University-Tulsa in the 74105 area are available at The Enclave at Brookside. Offering both one and two-bedroom apartments, our community combines prime location with modern living.\n\nResidents enjoy a wide range of amenities, from a relaxing yoga studio and game room to a refreshing pool. Our pet-friendly community also features a dog play area. Just a short commute from campus, The Enclave provides the perfect balance of leisure and proximity, making it a great choice for students and faculty alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Oklahoma State University-Tulsa 74105",
      "seo_description": "Discover rentals near Oklahoma State University-Tulsa in 74105 at The Enclave, offering comfortable living with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near Saint Francis Hospital Tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital Tulsa",
      "h2_subtitle": "Find convenient apartments near Saint Francis Hospital Tulsa. Experience luxury living at The Enclave.",
      "page_copy": "The Enclave at Brookside offers ideal apartments near Saint Francis Hospital Tulsa, providing both comfort and convenience. Our premium one and two-bedroom apartment homes are designed to cater to modern living needs.\n\nEnjoy a range of amenities, including a tranquil yoga studio, state-of-the-art game room, and a sparkling pool. Our pet-friendly community features a designated dog park. With its perfect location and luxurious features, The Enclave is a premier choice for hospital staff and families seeking a serene living environment close to work.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital Tulsa",
      "seo_description": "Discover luxury apartments near Saint Francis Hospital Tulsa at The Enclave, offering comfort, convenience, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-close-to-ascension-st-john-medical-center-brookside",
      "search_query": "apartments close to Ascension St. John Medical Center Brookside OK",
      "category": "Hospital",
      "h1_title": "Apartments Close to Ascension St. John Medical Center",
      "h2_subtitle": "Discover convenient apartments close to Ascension St. John Medical Center in Brookside, OK. Enjoy a comfortable lifestyle at The Enclave.",
      "page_copy": "The Enclave at Brookside provides perfect living solutions for those seeking apartments close to Ascension St. John Medical Center in Brookside, OK. Choose from our stylish one and two-bedroom layouts, designed to enhance your living experience.\n\nResidents can relax in the yoga studio, engage in the game room, or lounge by the pool. Our pet-friendly community also includes a dog park, ensuring all members of your family feel at home. Located just minutes from the medical center, The Enclave offers an ideal mix of proximity and luxury for healthcare professionals and their families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Ascension St. John Medical Center",
      "seo_description": "Explore apartments close to Ascension St. John Medical Center in Brookside, OK at The Enclave, featuring modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-near-gathering-place-tulsa",
      "search_query": "apartments near gathering place tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Gathering Place Tulsa",
      "h2_subtitle": "Explore luxury apartments near Gathering Place Tulsa. The Enclave offers a blend of modern living and convenience.",
      "page_copy": "The Enclave at Brookside presents luxurious apartment living close to Gathering Place Tulsa. Our spacious one and two-bedroom apartments offer everything you need for a vibrant lifestyle.\n\nResidents enjoy premium amenities such as a serene yoga studio, interactive game room, and a refreshing outdoor pool. Our pet-friendly community, complete with a dedicated dog park, is perfect for those who love the outdoors. Just a short distance from the renowned Gathering Place, The Enclave combines ideal location with modern comforts, making it an excellent choice for anyone wanting to stay active and connected.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Gathering Place Tulsa",
      "seo_description": "Find stylish apartments near Gathering Place Tulsa at The Enclave, offering a perfect blend of location, luxury, and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-close-to-woodward-park-and-gardens-ok",
      "search_query": "apartments close to woodward park and gardens ok",
      "category": "Park",
      "h1_title": "Apartments Close to Woodward Park and Gardens OK",
      "h2_subtitle": "Discover apartments close to Woodward Park and Gardens, OK. The Enclave offers stunning features and proximity to nature.",
      "page_copy": "Experience the best of apartment living at The Enclave at Brookside, located close to the beautiful Woodward Park and Gardens in OK. With spacious one and two-bedroom options, our apartments provide a perfect retreat amidst the city.\n\nEnjoy a range of amenities including a calming yoga studio and vibrant game room, perfect for relaxation and entertainment. Our refreshing pool and dedicated dog park make it easy to appreciate both leisure and outdoor activities. Positioned near Woodward Park and Gardens, The Enclave combines the tranquility of nature with modern comforts, perfect for those seeking a harmonious living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Woodward Park and Gardens OK",
      "seo_description": "Live near nature at The Enclave, offering apartments close to Woodward Park and Gardens, OK. Experience luxurious amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-near-chandler-park-tulsa-county",
      "search_query": "apartments near chandler park tulsa county",
      "category": "Park",
      "h1_title": "Apartments Near Chandler Park Tulsa County",
      "h2_subtitle": "Looking for apartments near Chandler Park in Tulsa County? Discover the convenience and comfort at The Enclave.",
      "page_copy": "The Enclave at Brookside offers a prime location for those seeking apartments near Chandler Park in Tulsa County. Our modern one and two-bedroom homes are designed with your lifestyle in mind, providing the perfect balance of location and luxury.\n\nTake advantage of our community amenities, including a serene yoga studio, engaging game room, and an inviting pool area. Our pet-friendly community features a spacious dog park, ensuring that your furry friends can enjoy their new home. With easy access to Chandler Park, The Enclave provides a unique blend of city living and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chandler Park Tulsa County",
      "seo_description": "Discover apartments near Chandler Park in Tulsa County at The Enclave. Enjoy proximity to nature and top amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-close-to-lafortune-park-74105",
      "search_query": "apartments close to lafortune park 74105",
      "category": "Park",
      "h1_title": "Apartments Close to LaFortune Park 74105",
      "h2_subtitle": "Explore apartments close to LaFortune Park in the 74105 area. Discover the perfect living space at The Enclave.",
      "page_copy": "Find your ideal home at The Enclave at Brookside, located in the heart of Tulsa's 74105 area, just moments away from LaFortune Park. Our one and two-bedroom apartments offer modern designs and plentiful amenities suitable for an active lifestyle.\n\nResidents enjoy a variety of facilities including a peaceful yoga studio, lively game room, and a sparkling swimming pool. Our pet-friendly community also features a sizeable dog park, ensuring your pets feel welcome too. With LaFortune Park nearby, The Enclave offers the perfect fusion of urban convenience and serene green spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to LaFortune Park 74105",
      "seo_description": "Find apartments close to LaFortune Park in 74105 at The Enclave. Enjoy top amenities and a prime location in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5733056069500928",
      "source": "generator",
      "page_item_url": "apartments-near-guthrie-green-brookside",
      "search_query": "apartments near guthrie green brookside",
      "category": "Park",
      "h1_title": "Apartments Near Guthrie Green Brookside",
      "h2_subtitle": "Discover apartments near Guthrie Green in the Brookside area. Enjoy modern living at The Enclave.",
      "page_copy": "Welcome to The Enclave at Brookside, offering stylish living near Guthrie Green in the vibrant Brookside area. Our conveniently situated one and two-bedroom apartments provide a perfect blend of luxury and accessibility, ideal for enjoying Tulsa's cultural offerings.\n\nResidents can unwind with a range of amenities, including a serene yoga studio for relaxation, a game room for socializing, and a refreshing pool for leisurely swims. With a spacious dog park, even pets feel at home here. Proximity to Guthrie Green means you can experience local arts and music just steps from your front door, while enjoying the comfortable lifestyle at The Enclave.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island open to the living room.",
        "public_id": "019d01a2-472f-7038-840a-86b4a38608c7",
        "storage_key": "property/5733056069500928/019d01a2-472f-7038-840a-86b4a38608c7.webp",
        "width": 2560,
        "height": 1707
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Guthrie Green Brookside",
      "seo_description": "Explore modern apartments near Guthrie Green Brookside at The Enclave. Enjoy a dynamic location and abundant amenities in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5760"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9402129822"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MB77LLG2"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 7.3"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Homestead"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47726251875"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InprdHErVlZHMTJWSTB4Q0Y3enNpRUE9PSIsInZhbHVlIjoiSmdsbHJCLzREQmEwL2p6KytmNHErZz09IiwibWFjIjoiNThiZmRhNzFhNWQxNjJmMGU4YzVlZDE1NzM2NWVhZWUyODJhNGY5NmRhZmIwMDhjOGNjMGE0ZTcyOTllMjNjMiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "5760",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9402129822",
  "custom_google_gtm_id": "GTM-MB77LLG2",
  "custom_rollout_phase": "Phase 7.3",
  "custom_vibesites_theme": "Homestead",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47726251875",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InprdHErVlZHMTJWSTB4Q0Y3enNpRUE9PSIsInZhbHVlIjoiSmdsbHJCLzREQmEwL2p6KytmNHErZz09IiwibWFjIjoiNThiZmRhNzFhNWQxNjJmMGU4YzVlZDE1NzM2NWVhZWUyODJhNGY5NmRhZmIwMDhjOGNjMGE0ZTcyOTllMjNjMiJ9"
};

export const generatedAt = '2026-11-02T17:19:54.870Z';
